

/**
 * Measures rendered text width using a hidden DOM element.
 * @returns Function that computes width based on text and CSS styles.
 */
export function useTextWidth() {

    const container = document.body;
    const el = document.createElement('div');

    /**
     * Calculates the pixel width of the provided text using matching styles.
     * @param text - Text to measure.
     * @param cssStyles - Style declaration representing the target rendering context.
     * @returns Measured width in pixels.
     */
    const getWidth = (text: string, cssStyles: CSSStyleDeclaration) => {

        // copy relevant styles so measurement matches real cells:
        el.style.position = 'absolute';
        el.style.visibility = 'hidden';
        el.style.whiteSpace = 'nowrap'; // measure single-line width
        el.style.top = '-9999px';
        el.style.left = '-9999px';
        // copy font and text-related styles
        el.style.font = cssStyles.font || '';
        el.style.fontSize = cssStyles.fontSize || '';
        el.style.fontFamily = cssStyles.fontFamily || '';
        el.style.fontWeight = cssStyles.fontWeight || '';
        el.style.letterSpacing = cssStyles.letterSpacing || '';
        el.style.padding = cssStyles.padding || '';
        el.style.boxSizing = cssStyles.boxSizing || 'content-box';

        el.innerText = text;

        container.appendChild(el);
        const measured = el.getBoundingClientRect().width;
        container.removeChild(el);

        return measured;
    }

    return getWidth;



}